import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { MdMovie, MdVisibility, MdVisibilityOff, MdPerson } from '../utils/icons';
import { MdLockOutline } from 'react-icons/md';
import { toJalali } from '../utils/dateHelpers';

export default function Login() {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(form.username, form.password);
    if (result.success) {
      toast.success('خوش آمدید!');
      navigate('/');
    } else {
      toast.error(result.message);
    }
  };

  return (
    <div className="relative animated-bg min-h-screen flex items-center justify-center p-4 overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-70" />
        <div className="absolute -bottom-24 -left-24 w-80 h-80 bg-purple-100 rounded-full blur-3xl opacity-70" />
      </div>

      <div className="relative w-full max-w-md fade-in">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center mx-auto mb-4 glow-blue shadow-lg shadow-blue-200">
            <MdMovie size={30} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-1">سیستم مدیریت ویدا پرودکشن</h1>
          <p className="text-gray-500 text-sm">وارد حساب خود شوید تا کارتان را ادامه دهید</p>
        </div>

        {/* Form */}
        <div className="glass-card p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">نام کاربری</label>
              <div className="relative">
                <MdPerson size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-blue-500" />
                <input
                  type="text"
                  value={form.username}
                  onChange={e => setForm({ ...form, username: e.target.value })}
                  className="form-input pr-10"
                  placeholder="نام کاربری خود را وارد کنید"
                  required
                  autoFocus
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">پسورد</label>
              <div className="relative">
                <MdLockOutline size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-blue-500" />
                <input
                  type={showPass ? 'text' : 'password'}
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  className="form-input pr-10 pl-10"
                  placeholder="پسورد خود را وارد کنید"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 transition-colors"
                >
                  {showPass ? <MdVisibilityOff size={17} /> : <MdVisibility size={17} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-xl bg-blue-600 hover:bg-blue-500 text-white font-semibold transition-all glow-blue shadow-md shadow-blue-200 disabled:opacity-50 disabled:cursor-not-allowed mt-2"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  در حال ورود...
                </span>
              ) : 'ورود به سیستم'}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-gray-500 mt-5">
          © {toJalali(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate())[0]} سیستم مدیریت ویدا پرودکشن
        </p>
      </div>
    </div>
  );
}
